import React from "react";
import { GoogleOutlined, FacebookOutlined } from "@ant-design/icons";
import styled from "styled-components";
import Particles from "react-tsparticles";
import { provider, auth } from "../firebase";

function Login() {
  const signIn = (e) => {
    e.preventDefault();
    auth.signInWithPopup(provider).catch((err) => alert(err.message));
  };
  return (
    <>
      <HeaderContainer>
        <Header>
          <img
            src="https://hindustanuniv.ac.in/assets/images/HITS-Logo.png"
            alt=""
          />

          <h1>HITS-CONNECT</h1>
        </Header>
      </HeaderContainer>
      <Particles
        id="tsparticles"
        options={{
          background: {
            color: {
              value: "#D4E6F1",
            },
          },
          fpsLimit: 60,
          interactivity: {
            detectsOn: "canvas",
            events: {
              onClick: {
                enable: false,
                mode: "push",
              },
              onHover: {
                enable: false,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 6,
                opacity: 0.8,
                size: 30,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.3,
              },
            },
          },
          particles: {
            color: {
              value: "#000000",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 6,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />{" "}
      <AppBody>
        <CardContainer>
          <CardInnerContainer>
            <CardImageContainer>
              <ImgContainer>
                <img
                  width="520px"
                  src="https://static.toiimg.com/thumb/resizemode-4,width-1200,height-900,msid-76741887/76741887.jpg?imglength=1144522"
                />
              </ImgContainer>

              <h1>Sign in to HITS-Connect</h1>

              <button onClick={signIn}>Sign In With Google</button>
            </CardImageContainer>
          </CardInnerContainer>
        </CardContainer>
      </AppBody>
    </>
  );
}

export default Login;

const HeaderContainer = styled.div`
  display: flex;
  height: 60px;
  width: 100%;
  background-color: blue;
  flex-wrap: wrap;
  box-shadow: 5px 5px 3.5px 0px rgba(0, 0, 0, 0.75);
  align-items: center;
  position: fixed;
  margin: auto !important;
`;
const Header = styled.div`
  display: flex;
  flex-wrap: wrap;

  > img {
    height: 50px;
    display: flex;
    margin-left: 10px;
    flex-wrap: wrap;

    justify-content: center;
  }

  > h1 {
    display: flex;
    margin: auto;
    flex-wrap: wrap;
    margin-left: 410px;
    color: white;
    font-size: 22px;
    align-items: center;
  }
`;

const AppBody = styled.div`
  background-image: url("");
  height: 100vh;
  width: 100%;
  object-fit: contain;
  position: relative;
  z-index: 999;
  margin-top: -680px;
`;

const CardContainer = styled.div`
  display: grid;
  height: 100vh;
  place-items: center;
`;

const CardInnerContainer = styled.div`
  padding: 100px;
  text-align: center;
  background-color: white;
  border-radius: 10px;
  object-fit: contain;
  width: 300px;
  height: 60px;
  border: 3px solid rgba(0, 0, 0, 0.7);
  // background-image: url("https://static.toiimg.com/thumb/resizemode-4,width-1200,height-900,msid-76741887/76741887.jpg?imglength=1144522");
  background-repeat: no-repeat;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0.24);
`;

const CardImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > h1 {
    font-size: 20px;
    margin-top: -490px;
    color: black;
    display: none;
  }

  > button {
    height: 40px;
    margin-top: 20px;
    background-color: #f4d03f;
    border-radius: 10px;
    color: black;
    font-size: 12px;
  }
`;

const ImgContainer = styled.div`
  display: flex;

  justify-content: center;

  margin-top: -150px;
  margin-right: -5px;
  > img {
    border-radius: 37px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0.24);
  }
`;
